/**
 * An offer's context, saved to a file and opened again — the way a drawing is kept in Excalidraw.
 *
 * The dashboard keeps nothing on the server: its context travels in every form of the page, as one JSON
 * object. Saving writes that object to a `.fastast` file on the visitor's computer, wrapped with what it
 * is and when it was saved; opening reads such a file in the browser and POSTs its context to the offer,
 * which validates it like any other. A file saved in one offer opens in another: the keys it does not use
 * are kept for later.
 *
 * Both only act where their markup is ([data-offer-file-save], [data-offer-file-open]); elsewhere this
 * module loads and does nothing. Without it, the dashboard still works — only the file is missing.
 */

const FORMAT = 'fastast-context';

function download(name, text) {
	const url = URL.createObjectURL(new Blob([text], { type: 'application/json' }));
	const link = document.createElement('a');
	link.href = url;
	link.download = name;
	document.body.append(link);
	link.click();
	link.remove();
	setTimeout(() => URL.revokeObjectURL(url), 0);
}

function contextOf(text) {
	try {
		const file = JSON.parse(text);
		if (file && file.format === FORMAT && file.context && typeof file.context === 'object' && !Array.isArray(file.context)) {
			return file.context;
		}
	} catch {
		// Not JSON: said below, like any other file that is not a context.
	}
	return null;
}

document.addEventListener('click', (event) => {
	const button = event.target.closest('[data-offer-file-save]');
	if (!button) {
		return;
	}
	let context = {};
	try {
		context = JSON.parse(button.dataset.offerContext || '{}');
	} catch {
		context = {};
	}
	const slug = button.dataset.offerSlug || 'offer';
	const file = { format: FORMAT, version: 1, offer: slug, savedAt: new Date().toISOString(), context };
	download(`${slug}.fastast`, JSON.stringify(file, null, 2));
});

document.addEventListener('change', (event) => {
	const input = event.target.closest('[data-offer-file-open]');
	if (!input || !input.files || !input.files.length) {
		return;
	}
	const form = document.getElementById(input.dataset.offerFileOpen);
	const error = document.querySelector('[data-offer-file-error]');
	input.files[0].text().then((text) => {
		const context = contextOf(text);
		input.value = '';
		if (!context || !form) {
			if (error) {
				error.hidden = false;
			}
			return;
		}
		if (error) {
			error.hidden = true;
		}
		form.querySelector('input[name="context"]').value = JSON.stringify(context);
		form.submit();
	});
});
